import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Hombres y mujeres de 20 a 50 años.', 'Personas con ingresos variables o sin empleo estable.', 'Quienes ya han intentado otros métodos sin éxito.', 'Personas que quieren un método claro y práctico.', 'Freelancers que desean complementar sus servicios.'];
  const isNotFor = ['Quienes buscan dinero rápido sin esfuerzo.', 'Personas que no dedicarán unas horas a la semana.', 'Quienes quieren un negocio físico con mucho inventario.', 'Personas que buscan resultados milagrosos.'];
  return <section className="py-24 px-6 lg:px-8 bg-white text-slate-900 border-t border-slate-100" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark" data-id="element-4">
            ¿Es para ti?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 rounded-3xl p-8 border border-slate-200" data-id="element-6">
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-7">
              Sí es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-8">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-9">
                  <div className="p-1 bg-green-100 rounded-full shrink-0 mt-0.5" data-id="element-10">
                    <Check className="w-4 h-4 text-green-600 font-bold" data-id="element-11" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-slate-50 rounded-3xl p-8 border border-slate-200" data-id="element-13">
            <h3 className="font-heading text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-14">
              No es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-15">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-16">
                  <div className="p-1 bg-red-100 rounded-full shrink-0 mt-0.5" data-id="element-17">
                    <X className="w-4 h-4 text-red-500 font-bold" data-id="element-18" />
                  </div>
                  <span className="text-slate-600" data-id="element-19">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}